<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-6">
          <h1>Install Or Repair VPN Server</h1>
        </div>
        <div class="col-xs-6 mandatoryDiv">
          <span class="mandatory_color">(*)</span>
          <span class="letter-right"> Marked are required field</span>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-info" v-if="alert_message">
            {{ alert_message }}
          </div>
        </div>
        <form role="form">
          <div class="col-sm-6">
            <div class="box">
              <div class="box-header">
                <h3 class="box-title">Required Information</h3>
              </div>
              <div class="box-body form-box-body form-horizontal">
                <div class="form-group">
                  <label class="col-md-4 control-label"
                    >Public IP <span class="mandatory_horizontal">*</span></label
                  >
                  <div class="col-md-8">
                    <input
                      name="server_ip"
                      v-model="server_ip"
                      id="server_ip"
                      class="form-control input-sm"
                      value=""
                      placeholder="VPN Server Public IP"
                      type="text"
                      disabled
                    />
                    <label v-if="error_server_ip" class="error" for="name">{{
                      error_server_ip
                    }}</label>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-4 control-label"
                    >SSH IP <span class="mandatory_horizontal">*</span></label
                  >
                  <div class="col-md-8">
                    <input
                      name="server_ssh_ip"
                      v-model="server_ssh_ip"
                      id="server_ssh_ip"
                      class="form-control input-sm"
                      value=""
                      placeholder="VPN Server SSH IP"
                      type="text"
                    />
                    <label v-if="error_server_ssh_ip" class="error" for="name">{{
                      error_server_ssh_ip
                    }}</label>
                  </div>
                </div>


                <div class="form-group">
                  <label class="col-md-4 control-label"
                    >SSH Password<span class="mandatory_horizontal"
                      >*</span
                    ></label
                  >
                  <div class="col-md-8">
                    <input
                      name="server_password"
                      id="server_password"
                      class="form-control input-sm"
                      v-model="server_password"
                      value=""
                      placeholder="Enter SSH Password"
                      type="text"
                    />
                    <label
                      v-if="error_server_password"
                      class="error"
                      for="name"
                      >{{ error_server_password }}</label
                    >
                  </div>
                </div>

                <div class="form-group" v-if="is_shadowsocks">
                  <label class="col-md-4 control-label"
                    >ShadowSocks Port<span class="mandatory_horizontal"
                      >*</span
                    ></label
                  >
                  <div class="col-md-8">
                    <input
                      name="ss_port"
                      id="ss_port"
                      class="form-control input-sm"
                      v-model="ss_port"
                      value=""
                      placeholder="Enter ShadowSocks Port"
                      type="text"
                    />
                    <label v-if="error_ss_port" class="error" for="name">{{
                      error_ss_port
                    }}</label>
                  </div>
                </div>

                <div class="form-group" v-if="is_shadowsocks">
                  <label class="col-md-4 control-label"
                    >ShadowSocks Password<span class="mandatory_horizontal"
                      >*</span
                    ></label
                  >
                  <div class="col-md-8">
                    <input
                      name="ss_password"
                      id="ss_password"
                      class="form-control input-sm"
                      v-model="ss_password"
                      value=""
                      placeholder="Enter ShadowSocks Password"
                      type="text"
                    />
                    <label v-if="error_ss_password" class="error" for="name">{{
                      error_ss_password
                    }}</label>
                  </div>
                </div>

                <div class="form-group" v-if="is_openvpn">
                  <label class="col-md-4 control-label"
                    >Primary Radius Server IP
                    <span class="mandatory_horizontal">*</span></label
                  >
                  <div class="col-md-8">
                    <input
                      name="auth_server_primary_ip"
                      v-model="auth_server_primary_ip"
                      id="auth_server_primary_ip"
                      class="form-control input-sm"
                      value=""
                      placeholder="Primary Radius Server IP(Ex:000.000.000.000)"
                      type="text"
                    />
                    <label
                      v-if="error_auth_server_primary_ip"
                      class="error"
                      for="name"
                      >{{ error_auth_server_primary_ip }}</label
                    >
                  </div>
                </div>

                <div class="form-group" v-if="is_openvpn">
                  <label class="col-md-4 control-label"
                    >Secondary Radius Server IP
                    <span class="mandatory_horizontal">*</span></label
                  >
                  <div class="col-md-8">
                    <input
                      name="auth_server_secondary_ip"
                      v-model="auth_server_secondary_ip"
                      id="auth_server_secondary_ip"
                      class="form-control input-sm"
                      value=""
                      placeholder="Secondary Radius Server IP(Ex:000.000.000.000)"
                      type="text"
                    />
                    <label
                      v-if="error_auth_server_secondary_ip"
                      class="error"
                      for="name"
                      >{{ error_auth_server_secondary_ip }}</label
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-4 control-label"
                    >Install Protocol<span class="mandatory_horizontal"
                      >*</span
                    ></label
                  >
                  <div class="col-md-8">
                    <div class="col-md-4 border-left border-right">
                      <div class="form-group">
                        <label class="col-md-9 control-label">Open VPN</label>
                        <div class="col-md-3">
                          <input
                            name="is_openvpn"
                            type="checkbox"
                            v-model="is_openvpn"
                            id="is_openvpn"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 border-left border-right">
                      <div class="form-group">
                        <label class="col-md-9 control-label">WireGuard</label>
                        <div class="col-md-3">
                          <input
                            name="is_wireguard"
                            type="checkbox"
                            v-model="is_wireguard"
                            id="is_wireguard"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 border-left border-right">
                      <div class="form-group">
                        <label class="col-md-9 control-label"
                          >Shadowsocks</label
                        >
                        <div class="col-md-3">
                          <input
                            name="is_shadowsocks"
                            type="checkbox"
                            v-model="is_shadowsocks"
                            id="is_shadowsocks"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label
                        v-if="error_protocol_selection"
                        class="error"
                        for="name"
                        >{{ error_protocol_selection }}</label
                      >
                    </div>
                  </div>
                </div>

                <div style="margin-top: 25px" class="form-group">
                  <div class="col-md-12 btnCenter">
                    <div v-if="!loading">
                      <a
                        @click="formSubmit"
                        class="btn btn-submit btn-submit-big"
                      >
                        {{ ovpn_status == 3 ? "Install" : "Repair" }}
                      </a>
                    </div>
                    <div v-else>
                      <span
                        style="
                          font-weight: 700;
                          font-size: 14px;
                          color: orangered;
                          margin-bottom: 10px;
                        "
                        >Server Provisioning Start. Please Wait.
                        <img :src="loaderGif" alt="Loading" />
                      </span>
                      <div
                        class="alert text-center alert-warning alert-dismissible text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show"
                        role="alert"
                        data-brk-library="component__alert"
                      >
                        <i
                          class="start-icon fa fa-info-circle faa-shake animated"
                        ></i>
                        <strong class="font__weight-semibold"
                          >Attention!</strong
                        >
                        Please Don't Reload When Server Provisioning.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="box">
              <div class="box-header">
                <h3 class="box-title">Console</h3>
              </div>
              <div class="box-body form-box-body form-horizontal">
                <pre
                  :class="output.installation_status == 1 ? 'success' : 'error'"
                >
                  <div class="success" v-if="loading">
                     Processing....
                  </div>
                  {{ output.openvpn_log }}
                  {{ output.auth_server_log }}
                  {{ output.wireguard_log }}
                  {{ output.automation_log }}
                  {{ output.shadowsocks_log }}
                </pre>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";

// Force to use local DNS
export default {
  name: "VpnInstaller",
  data() {
    return {
      loaderGif: "/assets/img/provisoning.gif",
      value: null,
      id: "",
      server_ip: "",
      server_ssh_ip: "",
      server_password: "",
      auth_server_primary_ip: "10.10.10.21",
      auth_server_secondary_ip: "10.10.10.31",
      ss_port: "",
      ss_password: "",
      install_private_dns: 1,
      public_dns_type: 0,
      public_dns_ip: "10.8.0.1",

      ovpn_status: "",
      output: "",
      loading: false,
      isEditing: false,
      alert_message: "",
      LabelFormName: "Add New",
      error_server_password: false,
      error_server_ip: false,
      error_server_ssh_ip: false,
      error_auth_server_primary_ip: false,
      error_auth_server_secondary_ip: false,
      error_cityLists: false,
      error_ss_port: false,
      error_ss_password: false,

      is_openvpn: false,
      is_wireguard: false,
      is_shadowsocks: false,
      is_automation: false,
      error_protocol_selection: false,
    };
  },
  mounted: function () {
    //$(".select2").select2();
  },
  created() {
    loader.show();
    var rootObject = this;
    if (this.$route.params.id) {
      rootObject.isEditing = true;
      rootObject.id = this.$route.params.id;
      rootObject.getEditData();
    }
  },
  methods: {
    labelWithCity({ label, city }) {
      return `${label} — [${city}]`;
    },
    getEditData() {
      loader.show();
      let rootObject = this;
      rootObject.LabelFormName = "Edit";
      axios
        .get("vpn-servers/" + rootObject.id)
        .then(function (response) {
          rootObject.server_ip = response.data.ip;
          rootObject.ovpn_status = response.data.ovpn_status;

          loader.hide();
        })
        .catch(function (error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          console.log(alertmessage);
          rootObject.alert_message = alertmessage;
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    formSubmit(e) {
      e.preventDefault();
      var rootObject = this;
      var result = this.fromValidation();
      if (result) {
        setTimeout(function () {
          rootObject.error_server_password = false;
          rootObject.error_ip = false;
          rootObject.error_server_ssh_ip = false;
          rootObject.error_auth_server_primary_ip = false;
          rootObject.error_auth_server_secondary_ip = false;
          rootObject.error_protocol_selection = false;
          rootObject.error_ss_port = false;
          rootObject.error_ss_password = false;
        }, 5000);
        return 0;
      }

      var is_openvpn = this.is_openvpn === true ? 1 : 0;
      var is_wireguard = this.is_wireguard === true ? 1 : 0;
      var is_shadowsocks = this.is_shadowsocks === true ? 1 : 0;
      var is_automation = this.is_automation === true ? 1 : 0;

      //loader.show();
      rootObject.loading = true;
      let querystr = "";
      const form = new FormData();
      form.append("server_id", this.id);
      form.append("server_ip", this.server_ip);
      form.append("server_ssh_ip", this.server_ssh_ip);
      form.append("server_password", this.server_password);
      form.append("auth_server_primary_ip", this.auth_server_primary_ip);
      form.append("auth_server_secondary_ip", this.auth_server_secondary_ip);

      form.append("ss_port", this.ss_port);
      form.append("ss_password", this.ss_password);

      form.append("is_openvpn", is_openvpn);
      form.append("is_wireguard", is_wireguard);
      form.append("is_shadowsocks", is_shadowsocks);
      form.append("is_automation", is_automation);

      form.append("install_private_dns", this.install_private_dns);
      form.append("public_dns_type", this.public_dns_type);
      form.append("public_dns_ip", this.public_dns_ip);

      var config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      axios
        .post("ovpn-provisioning", form, config)
        .then(function (response) {
          //console.log(response);
          rootObject.output = response.data;
          rootObject.loading = false;

          if (is_wireguard == 1) {
            if (response.data.wireguardconfig) {
              rootObject.generateDownloadFile(
                response.data.wireguardconfig,
                "wireguard",
                "wgconfig"
              );
            }
          }

          loader.hide();
        })
        .catch(function (error) {
          rootObject.loading = false;
          rootObject.com_errorHandel(error);
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          rootObject.alert_message = alertmessage;
        });

      setTimeout(function () {
        rootObject.alert_message = "";
      }, 5000);
    },

    generateDownloadFile(result, protocolType, name) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(result)
      );
      if (protocolType == "openvpn") {
        element.setAttribute("download", name + ".ovpn");
      } else {
        element.setAttribute("download", name + ".conf");
      }
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },

    onFileSelected(event) {
      this.wireguard_file = event.target.files[0];
    },

    fromValidation(reset = false) {
      var has_error = false;
      if (!this.server_password) {
        this.error_server_password = "This field is required";
        has_error = true;
      }

      if (!this.server_ip) {
        this.error_server_ip = "This field is required";
        has_error = true;
      }
      if (!this.server_ssh_ip) {
        this.error_server_ssh_ip = "This field is required";
        has_error = true;
      }
      if (this.is_openvpn) {
        if (!this.auth_server_primary_ip) {
          this.error_auth_server_primary_ip = "This field is required";
          has_error = true;
        }
        if (!this.auth_server_secondary_ip) {
          this.error_auth_server_secondary_ip = "This field is required";
          has_error = true;
        }
      }

      if (this.is_shadowsocks) {
        if (!this.ss_port) {
          this.error_ss_port = "This field is required";
          has_error = true;
        }

        if (!this.ss_password) {
          this.error_ss_password = "This field is required";
          has_error = true;
        }
      }

      if (
        this.is_openvpn == false &&
        this.is_wireguard == false &&
        this.is_automation == false &&
        this.is_shadowsocks == false
      ) {
        this.error_protocol_selection = "Select atleast one protocol";
        has_error = true;
      }

      if (has_error) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.success {
  color: green;
}
.error {
  color: orangered;
}
pre {
  height: auto;
  max-height: 70vh;
  overflow: auto;
  background-color: #eeeeee;
  word-break: normal !important;
  word-wrap: normal !important;
  white-space: pre !important;
}
.alert > .start-icon {
  margin-right: 0;
  min-width: 20px;
  text-align: center;
}

.alert > .start-icon {
  margin-right: 5px;
}

.greencross {
  font-size: 18px;
  color: #25ff0b;
  text-shadow: none;
}

.alert-simple.alert-success {
  border: 1px solid rgba(36, 241, 6, 0.46);
  background-color: rgba(7, 149, 66, 0.12156862745098039);
  box-shadow: 0px 0px 2px #259c08;
  color: #0ad406;
  text-shadow: 2px 1px #00040a;
  transition: 0.5s;
  cursor: pointer;
}
.alert-success:hover {
  background-color: rgba(7, 149, 66, 0.35);
  transition: 0.5s;
}
.alert-simple.alert-info {
  border: 1px solid rgba(6, 44, 241, 0.46);
  background-color: rgba(7, 73, 149, 0.12156862745098039);
  box-shadow: 0px 0px 2px #0396ff;
  color: #0396ff;
  text-shadow: 2px 1px #00040a;
  transition: 0.5s;
  cursor: pointer;
}

.alert-info:hover {
  background-color: rgba(7, 73, 149, 0.35);
  transition: 0.5s;
}

.blue-cross {
  font-size: 18px;
  color: #0bd2ff;
  text-shadow: none;
}

.alert-simple.alert-warning {
  border: 1px solid rgba(241, 142, 6, 0.81);
  background-color: rgba(220, 128, 1, 0.16);
  box-shadow: 0px 0px 2px #ffb103;
  color: #ffb103;
  text-shadow: 2px 1px #00040a;
  transition: 0.5s;
  cursor: pointer;
}

.alert-warning:hover {
  background-color: rgba(220, 128, 1, 0.33);
  transition: 0.5s;
}

.warning {
  font-size: 18px;
  color: #ffb40b;
  text-shadow: none;
}

.alert:before {
  content: "";
  position: absolute;
  width: 0;
  height: calc(100% - 44px);
  border-left: 1px solid;
  border-right: 2px solid;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  height: 20px;
}

.fa-times {
  -webkit-animation: blink-1 2s infinite both;
  animation: blink-1 2s infinite both;
}

/**
 * ----------------------------------------
 * animation blink-1
 * ----------------------------------------
 */
@-webkit-keyframes blink-1 {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
@keyframes blink-1 {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
</style>
